var _dec, _class, _temp;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//@ts-nocheck

/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
import React from 'react';
import { StyleSheet, View } from 'react-native';
import { FalsyFC, FalsyText } from "../../devsupport";
import { styled } from "../../theme";
import { Popover } from "../popover/popover.component";
import { PopoverIndicator } from "../popover/popoverIndicator.component";
export
/**
 * Tooltip displays informative text when users focus on or tap an element.
 *
 * @extends React.Component
 *
 * @method {() => void} show - Sets Tooltip visible.
 *
 * @method {() => void} hide - Sets Tooltip invisible.
 *
 * @property {() => ReactElement} anchor - A component relative to which content component will be shown.
 *
 * @property {ReactText | (TextProps) => ReactElement} children - String, number or a function component
 * to render within the tooltip.
 * If it is a function, expected to return a Text.
 *
 * @property {boolean} visible - Whether content component is visible.
 * Defaults to false.
 *
 * @property {(ImageProps) => ReactElement} accessoryLeft - Function component
 * to render to start of the text.
 * Expected to return an Image.
 *
 * @property {(ImageProps) => ReactElement} accessoryRight - Function component
 * to render to end of the text.
 * Expected to return an Image.
 *
 * @property {() => void} onBackdropPress - Called when tooltip is visible and the underlying view was touched.
 * Useful when needed to close the modal on outside touches.
 *
 * @property {boolean} fullWidth - Whether a content component should take the width of `anchor`.
 *
 * @property {string | PopoverPlacement} placement - Position of the content component relative to the `anchor`.
 * Can be `left`, `top`, `right`, `bottom`, `left start`, `left end`, `top start`, `top end`, `right start`,
 * `right end`, `bottom start` or `bottom end`.
 * Defaults to *bottom*.
 *
 * @property {StyleProp<ViewStyle>} backdropStyle - Style of backdrop.
 *
 * @overview-example TooltipSimpleUsage
 * Tooltip accepts it's text as child element and is displayed relative to `anchor` view.
 *
 * @overview-example TooltipAccessories
 * Also, it may contain inner views configured with `accessoryLeft` and `accessoryRight` properties.
 * Within Eva it is expected to be an image or [svg icon](docs/guides/icon-packages).
 *
 * @overview-example TooltipStyledBackdrop
 * To style the underlying view, `backdropStyle` property may be used.
 *
 * @overview-example TooltipPlacement
 * By default, tooltip is displayed to the bottom of `anchor` view, but it is configurable with `placement` property.
 *
 * @overview-example TooltipStyling
 * Tooltip and it's inner views can be styled by passing them as function components.
 * In most cases this is redundant, if [custom theme is configured](docs/guides/branding).
 * ```
 * import { Tooltip, Text } from '../..';
 *
 * <Tooltip style={...}>
 *   {evaProps => <Text {...evaProps}>TEXT</Text>}
 * </Tooltip>
 * ```
 */
let Tooltip = (_dec = styled('Tooltip'), _dec(_class = (_temp = class Tooltip extends React.Component {
  constructor(...args) {
    super(...args);

    _defineProperty(this, "popoverRef", /*#__PURE__*/React.createRef());

    _defineProperty(this, "show", () => {
      var _this$popoverRef$curr;

      (_this$popoverRef$curr = this.popoverRef.current) === null || _this$popoverRef$curr === void 0 ? void 0 : _this$popoverRef$curr.show();
    });

    _defineProperty(this, "hide", () => {
      var _this$popoverRef$curr2;

      (_this$popoverRef$curr2 = this.popoverRef.current) === null || _this$popoverRef$curr2 === void 0 ? void 0 : _this$popoverRef$curr2.hide();
    });

    _defineProperty(this, "getComponentStyle", source => {
      const {
        indicatorBackgroundColor,
        iconWidth,
        iconHeight,
        iconMarginHorizontal,
        iconTintColor,
        textMarginHorizontal,
        textFontSize,
        textFontWeight,
        textFontFamily,
        textColor
      } = source,
            containerParameters = _objectWithoutProperties(source, ["indicatorBackgroundColor", "iconWidth", "iconHeight", "iconMarginHorizontal", "iconTintColor", "textMarginHorizontal", "textFontSize", "textFontWeight", "textFontFamily", "textColor"]);

      return {
        container: containerParameters,
        indicator: {
          backgroundColor: indicatorBackgroundColor
        },
        icon: {
          width: iconWidth,
          height: iconHeight,
          marginHorizontal: iconMarginHorizontal,
          tintColor: iconTintColor
        },
        text: {
          marginHorizontal: textMarginHorizontal,
          fontSize: textFontSize,
          fontWeight: textFontWeight,
          fontFamily: textFontFamily,
          color: textColor
        }
      };
    });

    _defineProperty(this, "renderPopoverIndicatorElement", props => {
      const evaStyle = this.getComponentStyle(this.props.eva.style);
      return /*#__PURE__*/React.createElement(PopoverIndicator, _extends({}, props, {
        style: [props.style, evaStyle.indicator]
      }));
    });
  }

  render() {
    const _this$props = this.props,
          {
      eva,
      style,
      accessoryLeft,
      accessoryRight,
      children
    } = _this$props,
          popoverProps = _objectWithoutProperties(_this$props, ["eva", "style", "accessoryLeft", "accessoryRight", "children"]);

    const evaStyle = this.getComponentStyle(eva.style);
    return /*#__PURE__*/React.createElement(Popover, _extends({}, popoverProps, {
      ref: this.popoverRef,
      style: [evaStyle.container, style],
      indicator: this.renderPopoverIndicatorElement
    }), /*#__PURE__*/React.createElement(View, {
      style: styles.content
    }, /*#__PURE__*/React.createElement(FalsyFC, {
      style: evaStyle.icon,
      component: accessoryLeft
    }), /*#__PURE__*/React.createElement(FalsyText, {
      style: evaStyle.text,
      component: children
    }), /*#__PURE__*/React.createElement(FalsyFC, {
      style: evaStyle.icon,
      component: accessoryRight
    })));
  }

}, _temp)) || _class);
const styles = StyleSheet.create({
  content: {
    flexDirection: 'row',
    justifyContent: 'center'
  }
});